import { Grid } from "@mui/material";
import moment from "moment";
import Panel from "../../../components/UI/Panel";
import AppDatePicker from "./AppDatePicker";
import GenericInput from "./UI/GenericInput";

interface ComponentProps {
    formik: any;
}

const OtherInfo = ({
    formik
}: ComponentProps) => {


    return (

        <Panel headerText="Others">
            <Grid spacing={2} mx={1} px={1} container>
                <Grid item xs={4} px={2}>
                    <AppDatePicker
                        keyName={`custodianDetails.entityMetric.lastRecordRetrievedDate`}
                        label="Last Record Retrieved Date"
                        value={formik?.values?.custodianDetails?.entityMetric?.lastRecordRetrievedDate || null}
                        onChange={(value: any) => {
                            formik?.setFieldValue(
                                `custodianDetails.entityMetric.lastRecordRetrievedDate`,
                                moment(value).format('YYYY-MM-DD'),
                            );
                        }}
                        errorMsg={''}
                        
                    />

                </Grid>
                <Grid item xs={4} px={2}>
                    <GenericInput
                        name="averageProcessingTime"
                        maxLength={16}
                        inputMode="numeric"
                        label="Average Processing Time"
                        placeholder="Average Processing Time"
                        value={formik?.values?.custodianDetails?.entityMetric?.averageProcessingTime}
                        onChange={(e: any) => {
                            formik?.setFieldValue(
                                `custodianDetails.entityMetric.averageProcessingTime`,
                                e.target.value,
                            );
                        }}
                        errorMsg={
                            formik?.errors?.custodianDetails?.entityMetric?.averageProcessingTime || ''
                        }
                        hasError={
                            !!formik?.errors?.custodianDetails?.entityMetric?.averageProcessingTime
                        }
                        onBlur={() => {
                            formik?.setFieldTouched(`custodianDetails.entityMetric.averageProcessingTime`, true);
                        }}
                    />
                </Grid>

            </Grid>
        </Panel>
    )
}

export default OtherInfo